export default function DocumentDetailView({ currentBusiness, doc, onBack, onGenerateVoidNC }) {
  return (
    <div className='bg-white p-6 rounded-2xl shadow space-y-4'>
      <div className='flex items-start justify-between'>
        <div>
          <h2 className='text-2xl font-semibold'>DOCUMENTO EMITIDO</h2>
          <p className='text-sm text-gray-600 mt-1'>
            En esta página se muestra el documento seleccionado y las opciones que el usuario tiene
            disponibles para trabajar con él.
          </p>
        </div>

        <div className='text-sm text-gray-700'>
          <span className='mr-2'>Empresa:</span>
          <span className='font-semibold'>{currentBusiness?.rut || '-'}</span>
        </div>
      </div>

      {/* Visor PDF */}
      <div className='border rounded bg-gray-50 overflow-hidden'>
        {doc?.pdf ? (
          <iframe
            title={`pdf-${doc?.folio}`}
            src={doc.pdf}
            className='w-full'
            style={{ height: '70vh' }}
          />
        ) : (
          <div className='p-6 text-sm text-gray-600'>Este documento no tiene PDF disponible.</div>
        )}
      </div>

      {/* Acciones (solo una, como pediste) */}
      <div className='pt-2'>
        <ul className='list-disc pl-6 space-y-2 text-sm'>
          <li>
            <button
              type='button'
              onClick={onGenerateVoidNC}
              className='text-[#0066CC] hover:underline font-medium'
            >
              Generar Nota de Crédito de Anulación
            </button>
            <div className='text-gray-700'>
              En esta opción podrá generar una Nota de Crédito Electrónica para Anular este
              documento.
            </div>
          </li>
        </ul>
      </div>

      <div className='flex justify-between pt-4'>
        <button type='button' onClick={onBack} className='cursor-pointer rounded-lg bg-primary px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-black/20 transition-all hover:bg-primary/90 active:scale-95'>
          Volver
        </button>
      </div>
    </div>
  )
}

